import React from 'react';
import {Route,Switch,useRouteMatch} from 'react-router-dom';

import VettingRequestForm from '../Components/VettingRequest/VettingRequestForm';
import DashboardPageAnalyst from '../Components/Dashboard/DashboardPageAnalyst';

import PageLoadEventEmitter from '../HoC/PageLoadEventEmitter';

export default function AnalystRoutes(){
    let match = useRouteMatch();
    
    return (
        <PageLoadEventEmitter>
            <Switch>
                <Route exact path={match.path+"/home"}>
                    <DashboardPageAnalyst />
                </Route>
                <Route path={match.path+"/request/:requestId"} > 
                    <VettingRequestForm />
                </Route>
            </Switch>
        </PageLoadEventEmitter>
    )
}